const nameTable = {
  0: 'X',
  1: 'Y',
  2: 'A',
  3: 'B',
  4: 'LB',
  5: 'RB',
  6: 'LT',
  7: 'RT',
  8: '←',
  9: '→',
  10: '↑',
  11: '↓'
}

export const gamepadButtonName = key => {
  if (key in nameTable) {
    return nameTable[key]
  } else {
    return ''
  }
}
